/* ─────────────────────────────────────────────────────────────────────────
   Koliza — Rasoir Skinova
   Storefront interactions: gallery, qty stepper, accordions,
   before/after carousel, add-to-cart → checkout redirect
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  "use strict";

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ── Gallery (thumbnails switch the main image) ─────────────────────── */
  $$(".sk-gallery").forEach((g) => {
    const main = $(".sk-main-media", g);
    const thumbs = $$(".sk-thumb", g);
    thumbs.forEach((t) => {
      t.addEventListener("click", () => {
        const src = t.dataset.full;
        if (src && main) {
          const img = $("img", main);
          if (img) img.src = src;
        }
        thumbs.forEach((x) => x.removeAttribute("data-active"));
        t.setAttribute("data-active", "1");
      });
    });
  });

  /* ── Quantity stepper ─────────────────────────────────────────────────── */
  $$(".sk-qty").forEach((q) => {
    const input = $('input[name="quantity"]', q) || $("input", q);
    const dec = $('[data-dec]', q);
    const inc = $('[data-inc]', q);
    const display = $('.sk-qty-val', q);
    const update = (v) => {
      const n = Math.max(1, parseInt(v, 10) || 1);
      if (input) input.value = n;
      if (display) display.textContent = n;
      updateAtcPrice(n);
    };
    if (dec) dec.addEventListener("click", () => update((parseInt(input?.value, 10) || 1) - 1));
    if (inc) inc.addEventListener("click", () => update((parseInt(input?.value, 10) || 1) + 1));
  });

  function updateAtcPrice(qty) {
    const btn = $(".sk-atc");
    if (!btn) return;
    const unit = parseFloat(btn.dataset.unitPrice || "0");
    const currency = btn.dataset.currency || "€";
    const label = btn.dataset.label || "Ajouter au panier";
    if (!unit) return;
    const total = (unit * qty).toFixed(2).replace(/\.00$/, "");
    const priceEl = $(".sk-atc-price", btn);
    if (priceEl) priceEl.textContent = total + " " + currency;
    else btn.querySelector(".sk-atc-label").textContent = label + " · " + total + " " + currency;
  }

  /* ── Add to cart → redirect to checkout ──────────────────────────────── */
  const form = $("form#sk-product-form");
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const btn = $(".sk-atc", form);
      if (btn) {
        btn.dataset.busyLabel = btn.dataset.busyLabel || "Redirection…";
        const lbl = $(".sk-atc-label", btn);
        if (lbl) lbl.textContent = btn.dataset.busyLabel;
        btn.disabled = true;
      }
      const fd = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: fd, headers: { Accept: "application/json" } })
        .then((r) => r.json())
        .then(() => { window.location.href = "/checkout"; })
        .catch(() => { form.submit(); });
    });
  }

  /* ── Accordions (FAQ + product details) ──────────────────────────────── */
  $$(".sk-acc").forEach((acc) => {
    const items = $$(".acc-item", acc);
    items.forEach((item) => {
      const trigger = $(".acc-trigger", item);
      if (!trigger) return;
      trigger.addEventListener("click", () => {
        const open = item.getAttribute("data-open") === "1";
        if (!acc.hasAttribute("data-multi")) {
          items.forEach((i) => i.setAttribute("data-open", "0"));
        }
        item.setAttribute("data-open", open ? "0" : "1");
      });
    });
  });

  /* ── Before/after carousel ───────────────────────────────────────────── */
  $$(".sk-results").forEach((r) => {
    const track = $(".sk-results-track", r);
    const prev = $("[data-prev]", r);
    const next = $("[data-next]", r);
    if (!track) return;
    const step = () => {
      const card = track.querySelector(".sk-result-card");
      return card ? card.getBoundingClientRect().width * 2 + 36 : 480;
    };
    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  });

  /* ── Newsletter (visual confirm only — Shopify form posts normally) ─── */
  $$(".sk-newsletter-form").forEach((f) => {
    f.addEventListener("submit", () => {
      const btn = $('button[type="submit"]', f);
      if (btn) {
        setTimeout(() => { btn.textContent = "Merci ✓"; }, 50);
      }
    });
  });
})();
